import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 1080.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)">

<path d="M5213 7443 c-7 -2 -13 -9 -13 -14 0 -5 -49 -75 -110 -154 -60 -80
-110 -150 -110 -155 0 -6 31 -10 70 -10 l70 0 0 -455 0 -456 58 3 57 3 3 623
c1 342 -1 622 -5 621 -5 0 -14 -3 -20 -6z"/>
<path d="M5387 7443 c-10 -10 -8 -1243 1 -1243 9 0 244 310 250 330 2 5 -27
10 -65 12 l-68 3 -3 453 -2 452 -53 0 c-30 0 -57 -3 -60 -7z"/>
<path d="M5783 7149 c-180 -89 -162 -347 30 -418 94 -36 221 19 268 116 40 83
24 192 -37 257 -62 65 -179 86 -261 45z"/>
<path d="M4640 5950 l0 -990 225 0 225 0 2 163 3 162 265 3 c146 1 275 0 288
-3 l23 -6 -3 -417 -3 -417 -28 -47 c-32 -54 -70 -89 -131 -121 -33 -17 -58
-22 -126 -22 -102 0 -163 25 -219 93 -57 68 -70 111 -70 240 l-1 112 -226 0
-227 0 6 -142 c6 -162 26 -250 83 -358 95 -182 277 -324 479 -375 95 -24 268
-24 354 -1 256 69 473 274 531 500 19 77 20 110 20 1178 l0 1098 -222 -2 -223
-3 -3 -448 -2 -447 -283 2 -282 3 -3 618 -2 617 -225 0 -225 0 0 -990z"/>
<path d="M1937 3523 c-4 -3 -7 -143 -7 -310 l0 -303 75 0 75 0 0 125 0 125
120 0 120 0 -1 -112 c-1 -62 0 -119 0 -126 1 -10 20 -12 74 -10 l72 3 3 299
c2 236 0 301 -10 308 -7 4 -41 8 -75 8 l-63 0 -1 -107 c-1 -60 -2 -115 -3
-123 -1 -12 -23 -16 -118 -18 l-118 -3 0 126 0 125 -68 0 c-38 0 -72 -3 -75
-7z"/>
<path d="M2762 3518 c-5 -7 -35 -83 -65 -168 -31 -85 -78 -217 -106 -293 -28
-76 -51 -141 -51 -143 0 -3 35 -4 78 -2 l77 3 15 45 c8 25 20 48 25 52 6 4 58
8 117 8 l107 0 19 -52 20 -53 76 -3 c42 -2 76 -1 76 1 0 4 -109 312 -154 437
-7 19 -23 64 -36 100 -13 36 -28 68 -34 72 -19 13 -153 9 -164 -4z m126 -283
c18 -50 32 -94 32 -98 0 -4 -34 -7 -75 -7 -41 0 -75 1 -75 3 0 3 55 169 65
196 9 22 19 4 53 -94z"/>
<path d="M3477 3523 c-4 -3 -7 -99 -7 -213 0 -223 -7 -265 -45 -274 -43 -11
-75 10 -75 52 0 21 -4 22 -75 22 l-75 0 0 -37 c0 -51 40 -113 92 -143 35 -21
56 -25 118 -25 86 0 125 17 165 69 36 47 45 117 45 347 0 170 -2 198 -16 203
-21 8 -119 8 -127 -1z"/>
<path d="M3901 3468 c-13 -35 -45 -124 -71 -198 -27 -74 -67 -186 -89 -247
l-41 -113 79 0 78 0 13 43 c22 68 21 68 143 65 l110 -3 17 -50 17 -50 76 -3
c42 -2 77 0 77 4 0 9 -62 185 -145 414 l-72 195 -84 3 -85 3 -23 -63z m148
-226 c17 -51 31 -97 31 -102 0 -6 -33 -10 -76 -10 -68 0 -75 2 -69 18 4 9 21
59 38 110 17 50 34 89 38 85 3 -5 20 -50 38 -101z"/>
<path d="M4575 3518 c-3 -7 -4 -146 -3 -308 l3 -295 165 0 c192 0 232 10 300
78 66 64 85 114 85 222 0 79 -4 97 -29 148 -31 65 -90 115 -166 143 -61 22
-348 32 -355 12z m267 -127 c26 -1 48 -10 74 -33 45 -40 64 -82 64 -143 0
-116 -79 -185 -212 -185 l-48 0 0 179 c0 193 -1 190 55 186 17 -1 47 -3 67 -4z"/>
<path d="M5403 3518 c-5 -7 -20 -42 -32 -78 -22 -62 -41 -114 -146 -398 -25
-68 -45 -125 -45 -128 0 -2 36 -4 79 -4 l79 0 13 50 c16 61 19 62 153 58 l100
-3 17 -50 17 -50 76 -3 c44 -2 76 1 76 7 0 5 -18 58 -39 118 -22 59 -70 191
-107 293 -36 102 -72 188 -78 192 -19 13 -153 9 -163 -4z m122 -268 c19 -57
35 -108 35 -112 0 -4 -34 -8 -76 -8 -68 0 -75 2 -69 18 3 9 20 61 38 114 17
54 32 96 34 94 2 -2 19 -50 38 -106z"/>
<path d="M5834 3516 c-3 -7 -4 -35 -2 -62 l3 -49 83 -3 82 -3 0 -244 0 -245
75 0 75 0 0 245 0 244 82 3 82 3 -3 55 c-1 30 -5 58 -7 62 -3 5 -109 8 -235 8
-186 0 -231 -3 -235 -14z"/>
<path d="M6566 3498 c-29 -69 -206 -566 -206 -577 0 -7 26 -11 74 -11 l73 0
19 53 19 52 112 3 112 3 14 -28 c8 -15 17 -40 21 -55 6 -28 8 -28 82 -28 l76
0 -5 28 c-4 23 -141 404 -195 542 l-18 45 -82 3 -83 3 -13 -33z m133 -254 c17
-50 31 -96 31 -103 0 -7 -25 -11 -70 -11 -48 0 -70 4 -70 12 0 25 65 207 71
200 4 -4 21 -48 38 -98z"/>
<path d="M7330 3514 c-121 -52 -156 -203 -66 -282 31 -27 130 -72 159 -72 15
0 80 -39 89 -54 28 -42 -10 -89 -68 -84 -31 2 -43 9 -59 35 -20 33 -20 33 -95
30 l-75 -2 3 -29 c3 -30 33 -80 62 -104 32 -26 88 -44 157 -49 65 -5 78 -3
128 22 66 32 105 84 112 149 10 87 -53 153 -186 197 -36 12 -78 30 -93 41 -51
35 -28 98 36 98 31 0 76 -30 76 -50 0 -6 35 -10 80 -10 89 0 91 2 65 63 -16
39 -64 83 -112 104 -43 18 -169 16 -213 -3z"/>
<path d="M7777 3523 c-4 -3 -7 -97 -7 -208 0 -214 8 -266 49 -324 81 -113 297
-121 398 -15 65 67 74 111 71 350 l-3 199 -70 0 -70 0 -5 -210 c-3 -115 -9
-218 -14 -227 -24 -52 -125 -66 -173 -24 l-28 24 -3 221 -3 221 -68 0 c-37 0
-71 -3 -74 -7z"/>
<path d="M8400 3220 l0 -310 177 0 c202 0 244 11 284 76 44 71 21 176 -47 216
l-35 21 28 18 c58 38 80 126 48 192 -35 73 -115 97 -327 97 l-128 0 0 -310z
m302 163 c22 -20 24 -66 2 -87 -11 -12 -36 -16 -90 -16 l-74 0 0 60 0 60 72 0
c52 0 76 -4 90 -17z m-6 -227 c24 -6 42 -47 36 -84 -5 -33 -59 -54 -130 -50
l-57 3 -3 59 c-2 32 -1 64 1 70 5 11 110 12 153 2z"/>
</g>
</svg>







    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
